import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './roomfull.scss'

const RoomFull = () => {

    useEffect(() => {
        document.title = 'FlashRoom'
    }, [])
    return (
        <div id='room-full' style={{ backgroundImage: `url('/images/cbb2.png')` }}>
            <div className='nav-2'>
                <div className='nav-logo-container'>
                    <img src='/images/flashroom-logo-light.png' height='44px' alt='FlashRoom logo' />
                    <h1>Flash<span>Room</span></h1>
                </div>
            </div>

            <div id='room-full-cont'>
                <h4>Room is full</h4>
                <p>This room has reached its member limit.</p>
                <Link className='ok-link' to='/'>OK</Link>
            </div>
        </div>
    )
}

export default RoomFull
